import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../components/Logo";

export default function RefundPolicy() {
  const navigate = useNavigate();
  return (
    <div style={s.wrapper}>
      <header style={s.header}>
        <div onClick={() => navigate("/app/")} style={{ cursor: "pointer" }}>
          <Logo size={28} showText={true} />
        </div>
      </header>
      <main style={s.main}>
        <h1 style={s.h1}>Refund Policy</h1>
        <p style={s.meta}>Last updated: January 1, 2025</p>

        <p style={s.p}>At BotSaathi, we are committed to delivering a high-quality WhatsApp automation experience. Please read our refund policy carefully before making a purchase.</p>

        <h2 style={s.h2}>1. Setup Fee</h2>
        <p style={s.p}>The one-time setup fee covers bot configuration, WhatsApp Business API integration, and onboarding support. <strong style={{ color: "#fff" }}>Setup fees are non-refundable</strong> once the onboarding process has been initiated.</p>

        <h2 style={s.h2}>2. Monthly Subscription</h2>
        <p style={s.p}>Monthly subscription payments are billed in advance. We offer a <strong style={{ color: "#fff" }}>7-day refund window</strong> from the date of each billing cycle if:</p>
        <ul style={s.ul}>
          <li style={s.li}>The platform was not functional due to a technical issue on our end.</li>
          <li style={s.li}>You were charged incorrectly or multiple times.</li>
        </ul>
        <p style={s.p}>Refunds will not be issued for:</p>
        <ul style={s.ul}>
          <li style={s.li}>Change of mind or unused subscription days.</li>
          <li style={s.li}>Downtime caused by Meta's WhatsApp API or third-party services.</li>
          <li style={s.li}>Accounts suspended for policy violations.</li>
        </ul>

        <h2 style={s.h2}>3. How to Request a Refund</h2>
        <p style={s.p}>To request a refund, contact us within the eligible window:</p>
        <ul style={s.ul}>
          <li style={s.li}>Email: <a href="mailto:support@botsaathi.com" style={s.link}>support@botsaathi.com</a></li>
          <li style={s.li}>Subject: "Refund Request — [Your Business Name]"</li>
          <li style={s.li}>Include your registered email, payment details, and reason for refund.</li>
        </ul>
        <p style={s.p}>We will review and respond to your request within 5 business days. Approved refunds are processed within 7–10 business days to your original payment method.</p>

        <h2 style={s.h2}>4. Cancellation</h2>
        <p style={s.p}>You may cancel your subscription at any time. Cancellation takes effect at the end of the current billing cycle. No partial refunds are issued for the remaining days of the cycle.</p>

        <h2 style={s.h2}>5. Contact</h2>
        <p style={s.p}>For refund queries:<br />
        <a href="mailto:support@botsaathi.com" style={s.link}>support@botsaathi.com</a><br />
        Ramnagar, Uttarakhand, India</p>
      </main>
      <footer style={s.footer}>
        <span style={{ color: "#444" }}>© 2025 BotSaathi. All rights reserved.</span>
        <a href="/privacy-policy" style={s.footerLink}>Privacy Policy</a>
        <a href="/terms-of-service" style={s.footerLink}>Terms of Service</a>
      </footer>
    </div>
  );
}

const s = {
  wrapper: { background: "#0a0a0a", minHeight: "100vh", color: "#d0d0d0" },
  header: { padding: "20px 40px", borderBottom: "1px solid #1a1a1a" },
  main: { maxWidth: 760, margin: "0 auto", padding: "60px 24px" },
  h1: { fontSize: 36, fontWeight: 700, color: "#fff", marginBottom: 8, fontFamily: "Georgia, serif" },
  h2: { fontSize: 20, fontWeight: 700, color: "#fff", marginTop: 36, marginBottom: 10 },
  meta: { fontSize: 13, color: "#555", marginBottom: 32 },
  p: { fontSize: 15, lineHeight: 1.8, color: "#888", marginBottom: 16 },
  ul: { paddingLeft: 20, marginBottom: 16 },
  li: { fontSize: 15, lineHeight: 1.8, color: "#888", marginBottom: 6 },
  link: { color: "#25d366", textDecoration: "none" },
  footer: { borderTop: "1px solid #1a1a1a", padding: "24px 40px", display: "flex", gap: 20, alignItems: "center", justifyContent: "center", flexWrap: "wrap" },
  footerLink: { fontSize: 13, color: "#555", textDecoration: "none" },
};
